/**
 * Контактні дані компанії — в одному місці.
 *
 * Раніше телефон і пошта були вписані руками у Navbar, Footer, Contact і
 * ContactPage: чотири копії, які вже встигли розійтися форматуванням
 * («+38 077 866 15 51» замість звичного українцям «+38 (077) 866-15-51»).
 * Зміна номера означала пошук по всьому проєкту й гарантовану пропущену копію.
 *
 * УВАГА щодо Telegram: посилання веде за номером телефону (t.me/+380…), бо
 * @username компанії невідомий. Такий лінк відкриває чат лише якщо на цьому
 * номері справді є Telegram. Щойно з'явиться username — замініть `href` у
 * `TELEGRAM` на `https://t.me/<username>`, решта сайту підхопить сама.
 */

const PHONE_DIGITS = '380778661551';

export const PHONE = {
  href: `tel:+${PHONE_DIGITS}`,
  // Український формат читається групами: код оператора в дужках, далі 3-2-2.
  label: '+38 (077) 866-15-51'
};

export const EMAIL = {
  href: 'mailto:visiamedicalgroup@gmail.com',
  label: 'visiamedicalgroup@gmail.com'
};

export const TELEGRAM = {
  href: `https://t.me/+${PHONE_DIGITS}`,
  label: 'Telegram',
  icon: 'fab fa-telegram'
};

export const VIBER = {
  // Плюс у query обов'язково закодований: без %2B Viber читає номер як
  // локальний і не знаходить контакт.
  href: `viber://chat?number=%2B${PHONE_DIGITS}`,
  label: 'Viber',
  icon: 'fab fa-viber'
};

/*
 * Тут була константа RESPONSE_TIME — «Відповідаємо протягом 2 годин у робочі
 * дні» — і вона стояла біля кожної кнопки відправлення, у футері, в блоці
 * контактів і в кінці кожної внутрішньої сторінки. Власник прибрав її з
 * сайту: це зобов'язання, а не рекламний рядок, і воно має або виконуватися
 * завжди, або не стояти ніде.
 *
 * Якщо колись повертати — повертати сюди, одним рядком на весь сайт, а не
 * копією в кожному місці.
 */

/**
 * Де ми. Точної адреси офісу на сайті поки немає — лише місто, тож і в
 * розмітці, і на ілюстрації в блоці «Де ми» (src/components/Location.js)
 * стоїть Львів, а не вулиця. Коли адреса з'явиться — вписати `street`.
 */
export const LOCATION = {
  city: 'Львів',
  region: 'Львівська область',
  street: null
};

/** Для schema.org: місто без вулиці — чесніше, ніж вигадана адреса. */
export const POSTAL_ADDRESS = {
  '@type': 'PostalAddress',
  addressLocality: LOCATION.city,
  addressRegion: LOCATION.region,
  addressCountry: 'UA'
};

/** Прямі канали зв'язку в тому порядку, у якому їх варто пропонувати. */
export const CHANNELS = [
  { key: 'phone', icon: 'fas fa-phone', title: 'Телефон', ...PHONE },
  { key: 'telegram', icon: TELEGRAM.icon, title: 'Telegram', href: TELEGRAM.href, label: PHONE.label },
  { key: 'viber', icon: VIBER.icon, title: 'Viber', href: VIBER.href, label: PHONE.label },
  { key: 'email', icon: 'fas fa-envelope', title: 'E-mail', ...EMAIL }
];

/*
 * Тут був CONTACT_METHODS — перемикач «як зручніше відповісти» у формі.
 * Прибрано разом із самим полем: сервер його більше не отримує, але й далі
 * приймає (server.js звіряє зі своїм списком), щоб сторінка, відкрита до
 * оновлення й залишена у вкладці, не отримала помилки при відправленні.
 */
